import React from 'react';
import darkBackgroundLogo from '../assets/SiameseAI_logo_dark_transparent_background.png';
import lightBackgroundLogo from '../assets/SiameseAI_logo_light_transparent_background.png';

function SiameseAILogoIcon({ className = '', onClick, title, size = 32 }) {
  const sharedAlt = 'SiameseAI';
  const sharedTitle = title || 'SiameseAI';
  const sharedStyle = { height: size, width: 'auto' };
  const baseClass = `select-none transition-opacity duration-200 ${className}`.trim();

  return (
    <>
      <img
        src={darkBackgroundLogo}
        alt={sharedAlt}
        title={sharedTitle}
        onClick={onClick}
        style={sharedStyle}
        className={`${baseClass} hidden dark:block`}
      />
      <img
        src={lightBackgroundLogo}
        alt={sharedAlt}
        title={sharedTitle}
        onClick={onClick}
        style={sharedStyle}
        className={`${baseClass} block dark:hidden`}
      />
    </>
  );
}

export default SiameseAILogoIcon;
